module.exports = __webpack_public_path__ + "assets/29f1ae48cb7912ed05ecf84e3f145716.svg";